module.exports = __webpack_public_path__ + "img/fuzzy-review.3482c5aa.svg";